<h1 mat-dialog-title>Datos completos del vehículo</h1>
<div mat-dialog-content>
  <div class="contenedor3 mb-4" *ngIf="vehiculo">
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3">
        <label>Nif Propietario</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.nifPropietario | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3">
        <label>Matricula</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.matricula | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3">
        <label>F.Matriculación</label>
        <div class="borde m-0">
          <p>
            <b>{{
              vehiculo.fechaMatriculacion | null | date : "dd/MM/yyyy"
            }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-3 p-0">
        <label>1ra Matriculación</label>
        <div class="borde m-0">
          <p>
            <b>{{
              vehiculo.fechaPrimeraMatriculacion | null | date : "dd/MM/yyyy"
            }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 p-0 pr-3">
        <label>Bastidor</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.bastidor | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 p-0">
        <label>Tipo</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.tipoVehiculo | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-2 col-md-4 col-sm-4 p-0 pr-3">
        <label>Marca</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.marca | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-3 col-md-8 col-sm-8 p-0 pr-3">
        <label>Modelo</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.modelo | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Color</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.color }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Carburante</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.carburante | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>Plazas</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.plazas | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-2 col-sm-2 p-0">
        <label>Cilindrada</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.cilindrada | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Codigo ITV</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.codigoItv | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>PMA</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.pma | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Tara</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.tara | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Carga útil</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.cargaUtil | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-3 col-md-8 col-sm-8 p-0 pr-3">
        <label>HP</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.hp | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-1 col-md-2 col-sm-2 p-0">
        <label>%</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.tantoPorCien | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>B.Imponible</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.baseImponible | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>Cuota</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.cuota | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>Categoría</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.categoria | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>NºJustificante 576</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.numeroJustificante576 | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-7 col-md-8 col-sm-8 p-0">
        <label>Tipo ITV</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.tipoitv | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>Potencia Neta ITV</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.potencianetaitv | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>NºTarjeta ITV</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.numeroTarjetaItv | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>NIF Introductor</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.nifIntroductor | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Apellido introductor</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.apellido1Introductor | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-8 col-sm-8 p-0 pr-3">
        <label>Apellido 2 Introductor</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.apellido2Introductor | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-8 col-sm-8 p-0">
        <label>Nombre Introductor</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.nombreIntroductor | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>CO2</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.co2 | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>KM</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.km | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>Codigo Observaciones</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.codigoObservaciones | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6 p-0 pr-3">
        <label>Hecho imponible</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.hechoImponible | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-4 col-md-8 col-sm-8 p-0">
        <label>Clasisificacion CEE</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.clasificacionCee | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>MOM</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.mom | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>Nivel emisiones</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.nivelemisiones | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>Ruedas</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.ruedas | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
        <label>Distancia Ejes</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.distanciaejes | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-1 col-md-8 col-sm-8 p-0 pr-3">
        <label>Via anterior</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.viaanterior | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-1 col-md-8 col-sm-8 p-0 pr-3">
        <label>Via posterior</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.viaposterior | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 col-sm-8 p-0">
        <label>Carroceria</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.carroceria | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-4 col-md-2 col-sm-2 p-0 pr-3">
        <label>Homologación</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.homologacion | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>Variante</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.variante | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>Versión</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.version | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-6 p-0">
        <label>Fabricante</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.fabricante | null }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: 15px">
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>MMTA</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.mmta | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 p-0 pr-3">
        <label>ECO Innovación</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.ecoinnovacion | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
        <label>ECO Reducción</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.ecoreduccion | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-1 col-md-6 col-sm-6 p-0 pr-3">
        <label>ECO Código</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.ecocodigo | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-1 col-md-8 col-sm-8 p-0 pr-3">
        <label>Rel.pot./peso</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.relacionPotenciaPeso | null }}</b>
          </p>
        </div>
      </div>

      <div class="col-lg-2 col-md-8 col-sm-8 p-0 pr-3">
        <label>Tipo fuel</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.tipoFuel | null }}</b>
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 col-sm-8 p-0">
        <label>NIVE</label>
        <div class="borde m-0">
          <p>
            <b>{{ vehiculo.nive | null }}</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cerrar</button>
</div>
